import { render, staticRenderFns } from "./Example.vue?vue&type=template&id=514cb5e1&scoped=true&"
import script from "./Example.vue?vue&type=script&lang=ts&"
export * from "./Example.vue?vue&type=script&lang=ts&"
import style0 from "./Example.vue?vue&type=style&index=0&id=514cb5e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514cb5e1",
  null
  
)

export default component.exports